import React, { useState } from 'react';
import { Box, Paper, Typography, TextField, Button } from '@mui/material';

interface TextInputProps {
  onInputComplete: (addresses: string[]) => void;
  onTextChange?: () => void;
}

const TextInput: React.FC<TextInputProps> = ({ onInputComplete, onTextChange }) => {
  const [text, setText] = useState('');
  const [error, setError] = useState<string | null>(null);

  const handleSubmit = () => {
    if (!text.trim()) {
      setError('Vui lòng nhập ít nhất một địa chỉ');
      return;
    }

    // Split by newlines and process each line
    const addresses = text
      .split('\n')
      .map(line => line.trim())
      .filter(line => line.length > 0); // Remove empty lines

    if (addresses.length === 0) {
      setError('Vui lòng nhập ít nhất một địa chỉ');
      return;
    }

    setError(null);
    onInputComplete(addresses);
  };

  return (
    <Box sx={{ mb: 4 }}>
      <Paper
        sx={{
          p: 3,
          display: 'flex',
          flexDirection: 'column',
          gap: 2,
        }}
      >
        <Typography variant="subtitle1" gutterBottom>
          Nhập danh sách địa chỉ (mỗi địa chỉ một dòng)
        </Typography>
        <TextField
          multiline
          rows={6}
          value={text}
          onChange={(e) => {
            setText(e.target.value);
            setError(null);
            if (onTextChange) onTextChange();
          }}
          placeholder="Nhập hoặc dán danh sách địa chỉ vào đây..."
          error={!!error}
          helperText={error}
          fullWidth
          sx={{
            '& .MuiOutlinedInput-root': {
              fontFamily: 'monospace',
            },
          }}
        />
        <Button
          variant="contained"
          onClick={handleSubmit}
          disabled={!text.trim()}
          sx={{ alignSelf: 'flex-end' }}
        >
          Xác nhận
        </Button>
      </Paper>
    </Box>
  );
};

export default TextInput; 